export const EDUCATION_ASSET_TYPE_ID = 15;
export const OTHER_EDUCATION_ID = 42;
